import { FormattedMessage, useIntl } from 'react-intl';

import { RootState } from './../../../reducers';

import * as CustomerUserActions from '../../../actions/customer-user';
import { CircularProgress, Grid } from '@material-ui/core';
import { CustomerRouteParams } from '../../../pages/customer/models';
import { EditCustomerForm } from '../users/editCustomer';
import { WikusPanel } from '@wikus-ui/components/core/card';
import { unwrapCustomerState } from '../../../utils/url';
import { useActions } from '../../../actions';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const CustomerSettings = () => {
  const intl = useIntl();
  const { id: customerId } = useParams<CustomerRouteParams>();
  const customerUserActions: typeof CustomerUserActions = useActions(CustomerUserActions);
  const customerUsers = useSelector((state: RootState) => unwrapCustomerState(state.customerUsers));

  useEffect(() => {
    if (customerId) {
      customerUserActions.fetchCustomerUsers(customerId);
    }
  }, []);

  return (
    <>
      <WikusPanel
        title={intl.formatMessage({ id: 'customers.tabs.settings' })}
      >
        {/* undefined = noch nicht geladen, [] = geladen ohne Benutzer (sonst dreht der Spinner ewig) */}
        {customerUsers === undefined ? (
          <CircularProgress style={{ width: '25px', height: '25px' }} color="inherit" />
        ) : customerUsers.length ? (
          <EditCustomerForm
            customerUser={customerUsers[0]}
            onEdit={() => customerUserActions.fetchCustomerUsers(customerId)}
          />
        ) : (
          <Grid container justifyContent="center">
            <FormattedMessage id="nothing-found" />
          </Grid>
        )}
      </WikusPanel>
    </>
  );
};
